import { useEffect, useState } from "react";

export default function usePromise<T>(caller: () => Promise<T>, deps: any[]) {
  const [data, setData] = useState<T | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const result = await caller();

      setData(result);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { loading: data === undefined, data };
}
